export default __webpack_public_path__ + "static/minutoli-89638abf6b242a2a92420450374ccb08.jpeg";